import { FormProvider, useForm } from "react-hook-form";
import { DocumentFormProps } from "./ValidationModal";
import { Box, Stack, TextField, Button } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import yup from "core/validation/yup-config";
import FieldDatepicker from "components/forms/fields/FieldDatepicker";

const schema = yup.object().shape({
  address: yup.string().required(),
  zip_code: yup.string().required(),
  city: yup.string().required(),
  sender_company_name: yup.string().required(),
  date_of_issue: yup.string().required(),
});

const ResidencyProofDocumentForm = ({ document, onApprove, onReject, disabled }: DocumentFormProps) => {
  const methods = useForm<any>({
    mode: 'onBlur',
    defaultValues: document.ocr_data,
    resolver: yupResolver(schema)
  });
  const { register, formState: { errors }, handleSubmit } = methods;

  return (
    <Box sx={{ height: '100%' }}>
      <FormProvider {...methods}>
        <Stack justifyContent="space-between" height="90%">
          <Stack gap={2}>
            <Stack direction="row" justifyContent="space-between" gap={2}>
              <FieldDatepicker disabled={disabled} fieldName="date_of_issue" label="Date de délivrance *" control={methods.control} sx={{ backgroundColor: 'white' }} />
              <TextField disabled={disabled} sx={{ backgroundColor: 'white' }} label="Société *" {...register('sender_company_name')} error={!!errors.sender_company_name} />
            </Stack>
            <Stack direction="row" justifyContent="space-between" gap={2}>
              <TextField disabled={disabled} sx={{ backgroundColor: 'white' }} label="Adresse *" {...register('address')} error={!!errors.address} />
            </Stack>
            <Stack direction="row" justifyContent="space-between" gap={2}>
              <TextField disabled={disabled} sx={{ backgroundColor: 'white' }} label="Code Postal *" {...register('zip_code')} error={!!errors.zip_code} />
              <TextField disabled={disabled} sx={{ backgroundColor: 'white' }} label="Ville *" {...register('city')} error={!!errors.city} />
            </Stack>
          </Stack>

          {!disabled && (
            <Stack direction="row" justifyContent="space-between" gap={2} mt={4}>
              <Button variant="outlined" color="error" onClick={onReject}>Refuser le document</Button>
              <Button variant="contained" color="primary" onClick={handleSubmit(onApprove)}>Valider</Button>
            </Stack>
          )}
        </Stack>
      </FormProvider>
    </Box>
  );
};

export default ResidencyProofDocumentForm;